import {MENU_ITEMS} from '../menu-items/index'

const menu = {
  getMenuItemsForCurrentRegion: function () {
    return JSON.parse(JSON.stringify(MENU_ITEMS))
  },
  _flatMenu: null,
  getFlatMenuItemsForCurrentRegion: function () {
    if (!this._flatMenu) {
      let copy = MENU_ITEMS.slice()
      this._flatMenu = {}
      copy.forEach(v => {
        this._flatMenu[v.name] = v
        if (v.childs) {
          let obj = {}
          obj = this._buildFlatTree(v.childs, obj, v)
          for (let key in obj) {
            obj[key].root = v
          }
          this._flatMenu = Object.assign(
            this._flatMenu,
            obj
          )
        }
        this._flatMenu[v.name].root = v
      })
      console.log('this._flatMenu', this._flatMenu)
      // this._buildFlatTree(copy)
    }
    return this._flatMenu
  },
  _buildFlatTree: function (items, fullOut, parent = null) {
    let out = fullOut || {}
    items.forEach(v => {
      out[v.name] = v
      if (parent) {
        out[v.name].parent = parent
      }
      if (v.childs) {
        out = this._buildFlatTree(v.childs, out, out[v.name])
      }
    })
    return out
  }
}

export default menu
